import React, { useState } from "react";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DownloadIcon from "@mui/icons-material/Download";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Axios from "axios";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  convertToCurrencyFormatQuantaty,
  convertToCurrencyFormat,
  millisecondsToStringDate,
  DATE_FORMAT,
} from "../../../../_helpers";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarQuickFilter,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import { RenderCellExpand } from "../../../../components/datagridtooltip/DataGridToolTip";
import Popup from "../../../../components/Popup/Popup";
import AllocationInventoryEdit from "./AllocationInventoryEdit";
import ExportExcelPopup from "../../../../components/exportPopup/ExportExcelPopup";
import { getAllocationInventoryListAction } from "../../../../_actions/subDealer.action";
import { DataFormat } from "../../../../_helpers/commonFunctions";
import { API_URL_LMS } from "../../../../Constant/index";
import DataGridProMUI from "../../../../components/DataGrid/DataGridProMUI";
import { SignalCellularNull } from "@mui/icons-material";
import { onExportExcel } from "../../../../_helpers/exportExcel";
import { isPermission, authorizedMessage } from "../../../../_helpers/commonAPI";
import { toast } from 'react-toastify';
import AuthorizedMessagePage from "../../../../components/AuthorizedMessagePage";
import AuthorizedMessage from "../../../../components/AuthorizedMessage";
import Loader from "../../../../components/Loader/Loader";

const AllocationInventoryList = (props) => {
  const [openPopup, setOpenPopup] = useState(false);
  const [isAddEdit, setIsAddEdit] = useState(false);
  const [isdelete, setIsdelete] = useState(false);
  const [openDeleteContactPopup, setOpenDeleteContactPopup] = useState(null);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [recordForDelete, setRecordForDelete] = useState(null);
  const [headerName, setHeaderName] = useState("Add Contact");
  const [tableData, setTableData] = useState([]);
  const allocatioInventory = useSelector((state) => state.allocatioInventory);
  const [openExportPopup, setOpenExportPopup] = useState(null);
  const [gridData, setGridData] = useState([]);
  const [pageSize, setPageSize] = React.useState(25);
  const history = useHistory();
  const [fileUrl, setFileUrl] = useState("");
  const [exportFiles, setExportFiles] = useState([])
  const [open, setOpen] = useState(false);
  const [searchedRows, setSearchedRows] = useState(null)
  const [exportState, setExportState] = useState("Export");
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const subdealerNumber = params.get("subDelearNumber");
  const customerNo = props.soldtoNumber;
  const dispatch = useDispatch();
  const [state, setState] = React.useState({
    message: "",
    severity: "",
    open: false,
  });



  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const onEditClick = async(e) => {

          const isAllow = await isPermission("SoldToManagement-AllocationInventory-edit")
          if (!isAllow) {
            toast.success(authorizedMessage, {
              position: toast.POSITION.TOP_RIGHT
            });
            return 0;
          }

          setHeaderName(
            `Allocation Inventory Item ${params.row.inventoryCode}`
          );
          setRecordForEdit(params.row);
          setOpenPopup(true);
          setIsAddEdit(false);
        };
        const onDeleteClick = (e) => {
          if (params.row.deleted) {
            return false;
          }
          setRecordForDelete(params.row);
          setOpenDeleteContactPopup(true);
          setIsdelete(false);
          setState({ open: false, severity: "", message: "" });
        };
        return (
          <div className="Action">
            <EditIcon className="EditIcon" onClick={onEditClick} />
          </div>
        );
      },
    },
    {
      field: "allocationInventoryItem",
      headerName: "Allocation Inventory Item",
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        const redirectToDetails = () => {
          history.push("/allocationInventory", { row });
        };
        return (
          <div
            onClick={redirectToDetails}
            style={{ color: "#007bff", cursor: "pointer" }}
          >
            {row.allocationInventoryItem}
          </div>
        );
      },
      width: 250,
    },
    {
      field: "company",
      headerName: "Company",
      headerAlign: "center",
      align: "center",
      width: 180,
    },
    {
      field: "billingYear",
      headerName: "Billing Year",
      headerAlign: "center",
      align: "center",
    },
    {
      field: "billingMonth",
      headerName: "Billing Month",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: ({ row }) => {
        return (
          <div>
            {row.billingMonth && row.billingMonth.length === 1
              ? "0" + row.billingMonth
              : row.billingMonth}
          </div>
        );
      },
    },
    {
      field: "productCode",
      headerName: "Product Number",
      headerAlign: "center",
      align: "center",
      width: 150,
      renderCell: RenderCellExpand,
      renderCell: ({ row }) => {
        return <>{row.productCode ? DataFormat(row.productCode) : ""}</>;
      },
    },
    {
      field: "productName",
      headerName: "Product Name",
      headerAlign: "center",
      align: "left",
      width: 250,
      renderCell: RenderCellExpand,
    },
    {
      field: "billingQty",
      headerName: "Billing Qty",
      headerAlign: "center",
      align: "right",
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return (
          <div>
            {row.billingQty !== null
              ? convertToCurrencyFormatQuantaty(row.billingQty)
              : ""}
          </div>
        );
      },
    },
    {
      field: "remainingQty",
      headerName: "Remaining Qty",
      headerAlign: "center",
      align: "right",
      width: 150,
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return <div>{convertToCurrencyFormatQuantaty(row.remainingQty)}</div>;
      },
    },
    {
      field: "autoAllocated",
      headerName: "Auto Allocated",
      headerAlign: "center",
      align: "right",
      width: 150,
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return <div>{convertToCurrencyFormatQuantaty(row.autoAllocated)}</div>;
      },
    },
    {
      field: "manuallyAllocated",
      headerName: "Manual Allocated",
      headerAlign: "center",
      align: "right",
      width: 150,
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return (
          <div>{convertToCurrencyFormatQuantaty(row.manuallyAllocated)}</div>
        );
      },
    },
    {
      field: "sumAllocated",
      headerName: "Sum Allocated ",
      headerAlign: "center",
      align: "right",
      width: 150,
      format: '#,##0.000',
      renderCell: ({ row }) => {
        return <div>{convertToCurrencyFormatQuantaty(row.sumAllocated)}</div>;
      },
    },
    {
      field: "expDate",
      headerName: "Expiration Date",
      width: 150,
      headerAlign: "center",
      align: "center",
      type: "date",
      valueFormatter: (row) => {
        return row.value && row.value !== null
          ? moment(new Date(row.value)).format("DD-MM-yyyy")
          : "";
      },
    },
    { field: 'bm', headerName: 'billingMonth', hide: true },
      { field: 'bq', headerName: 'billingQty', hide: true },
      { field: 'rq', headerName: 'remainingQty', hide: true },
      { field: 'aa', headerName: 'autoAllocated', hide: true },
      { field: 'ma', headerName: 'manualAllocated', hide: true },
      { field: 'sa', headerName: 'sumallocated', hide: true },
      { field: 'exDate', headerName: 'Expire date', hide: true },
      { field: 'by', headerName: 'monthyBull', hide: true }
  ];



  //export same as report starts here
  const onExportClick=()=>{
    const url = `export/allocation-inventory`;
    setExportState("Exporting...");
    // let filters={
    //   "fromDate": filterObj.startDate ? moment(filterObj.startDate).format("DD-MM-YYYY"): null,
    //   "toDate": filterObj.endDate ? moment(filterObj.endDate).format("DD-MM-YYYY"): null,
    //   "activityType": filterObj.activityType ? filterObj.activityType : null,
    //   "customerType": filterObj.customerType ? filterObj.customerType : null,
    //   "customerNumber": values.customerNumber ? values.customerNumber : null
    // }
    Axios({
        method: "POST",
        url: API_URL_LMS + url,
        data: {
          "customerId": customerNo
        },
        headers: {
            "Content-Type": "application/json",
            "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
            "X-SOLD-TO-ID": localStorage.getItem("CustomerNumber"),
        },
    })
        .then(async (response) => {
            setExportState("Export");
            setOpen(true);
            setFileUrl(response.data.data);
            exportExcelFile(response.data.data);
        })
        .catch((err) => { setExportState("Export");});
}


function exportExcelFile(file_url) {
  setExportFiles([])
  Axios({
      method: "GET", url: API_URL_LMS + `export/bucket?folderName=${file_url}`,
      headers: {
          "Content-Type": "application/json",
          'X-AUTH-TOKEN': localStorage.getItem('x-auth-token'),
          'X-SOLD-TO-ID': localStorage.getItem('CustomerNumber')
      }
  })
      .then(async (response) => {
          const newRes = Array.isArray(response.data.data) ? response.data.data : []
          setExportFiles(newRes)
      }).catch((err) => {
          // setExportState({ btnName: "EXPORT" });
      })
}
//export same as report ends here.

  React.useEffect(() => {
    dispatch(getAllocationInventoryListAction(customerNo));
  }, []);
  React.useEffect(() => {
    if (isAddEdit === true && openPopup === false)
      dispatch(getAllocationInventoryListAction(customerNo));
  }, [isAddEdit, openPopup]);

  React.useEffect(() => {
    const filterData =
      (allocatioInventory &&
        allocatioInventory.allocatioInventoryList &&
        allocatioInventory.allocatioInventoryList.data &&
        allocatioInventory.allocatioInventoryList.data.length > 0 &&
        allocatioInventory.allocatioInventoryList.data.map((e, i) => ({
          ...e,
          inventoryCode: Math.floor(Math.random() * 90000) + 10000,
          // expireDateString: millisecondsToStringDate(
          //   e.expirationDate,
          //   DATE_FORMAT
          // ),
          expDate: e.expirationDate != null ? new Date(e.expirationDate) : "",
          bm: e.billingDate ? moment(new Date(e.billingDate)).format("MM") : "",
          by: e.billingDate ? moment(new Date(e.billingDate)).format("MM") : "",
          exDate:e.expirationDate ? moment(new Date(e.expirationDate)).format("DD-MM-YYYY") : "",
          bq: convertToCurrencyFormatQuantaty(e.billingQty),
          rq: convertToCurrencyFormatQuantaty(e.remainingQty),
          aa: convertToCurrencyFormatQuantaty(e.autoAllocated),
          ma: convertToCurrencyFormatQuantaty(e.manuallyAllocated),
          sa: convertToCurrencyFormatQuantaty(e.sumAllocated),
          pr: convertToCurrencyFormat(e.pointsReceived),
        }))) ||
      [];
    setTableData(filterData);
  }, [allocatioInventory]);

  function modifyColumns(columns) {
    columns = columns.filter((item)=>!["actions", "pr", "bm", "bq", "rq", "aa", "ma", "sa", "exDate","by"].includes(item.field));
    return columns.map((item) => {
      return ({
        label: item.headerName,
        value: item.field,
        ...item
      })
    })
  }

  function modifyRows(rowdata) {
    // let filteredRow = searchedRows.map((item) => item.model);
    let filteredRow = rowdata.map((item) => item.model);
    const data = filteredRow.map((item) => {
      return ({
        ...item
      })
    })
    return data
  }

  function callExcelExport(data){
    const fileName = `ALLOCATION_INVENTORY_${moment(new Date()).format("DDMMyyyy")}`;
    const sheetName = `ALLOCATION_INVENTORY`
    onExportExcel(modifyColumns(columns), modifyRows(data), fileName ,sheetName)
  }
console.log("allocatioInventory =>", allocatioInventory)
  return (
    <>
    {allocatioInventory && (allocatioInventory.loading || allocatioInventory.errorMessage === 401) ? allocatioInventory.errorMessage === 401 ? <AuthorizedMessage /> : <Loader /> :
        <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={state.open}
        autoHideDuration={6000}
        key={"topright"}
      >
        <Alert
          severity={state.severity}
          sx={{ width: "100%" }}
          action={
            <Button
              color="inherit"
              size="small"
              onClick={() => {
                setState({ open: false });
              }}
            >
              Close
            </Button>
          }
        >
          {state.message}
        </Alert>
      </Snackbar>

      <div
        className="ContactDataGridContainer"
        style={{ marginTop: "20px", height: "350px" }}
      >
        {/* <DataGrid
          rows={tableData ? tableData : []}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          components={{
            Toolbar: CustomToolbar,
          }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
        /> */}
        <ExportExcelPopup
            title={"Customer"}
            fileName={"customer"}
            setOpen={setOpen}
            open={open}
            exportExcelFile={exportExcelFile}
            fileUrl={fileUrl}
            exportFiles={exportFiles}
        />
        <DataGridProMUI
          rows={tableData ? tableData : []}
          columns={columns}          
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}          
          onExportClick={onExportClick}
          exportState={exportState}
          loading={allocatioInventory.loading}
          setSearchedRows={setSearchedRows}
          callExcelExport={callExcelExport}
          defaultStateChange={false}
        />
      </div>
      {/* popup is a reusable custom dialog component */}
      <Popup
        title={headerName}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        maxWidth={"xs"}
        p={3}
      >
        <AllocationInventoryEdit
          setOpenPopup={setOpenPopup}
          recordForEdit={recordForEdit}
          setIsAddEdit={setIsAddEdit}
          subdealerNumber={subdealerNumber}
        />
      </Popup>
    </>
}
</>
  );
};

export default AllocationInventoryList;
